var styles = [".container[_ngcontent-%COMP%]{padding:1rem}"];
export { styles as styles };
